/*
            {
                ORDER_NUMBER = order.ORDER_NUMBER,
                ORDER_ITEM_NUMBER = ++onum,
                CURRENCY_CODE = oi.CURRENCY_CODE,
                CW_MARK = oi.CW_MARK,
                DATE_ISSUED = oi.DATE_ISSUED,
                DELIVERYTIME_DATE = oi.DELIVERYTIME_DATE,
                DELIVERYTIME_METHOD = oi.DELIVERYTIME_METHOD,
                DELIVERYTIME_WEEK = oi.DELIVERYTIME_WEEK,
                EntityState = Models.EntityStateEnum.New,
                EXMILL = oi.EXMILL,
                FSC = oi.FSC,
                ORDERED_BY = oi.ORDERED_BY,
                ORDER_ITEM_STATUS = oi.ORDER_ITEM_STATUS,
                ORDER_ITEM_TYPE = oi.ORDER_ITEM_TYPE,
                PEFC = oi.PEFC,

                PRODUCT_CODE = oi.PRODUCT_CODE,
                QUANTITY = oi.QUANTITY,
                SHIP_NO_EARLIER = oi.SHIP_NO_EARLIER,
                SHIP_NO_LATER = oi.SHIP_NO_LATER,
                WEIGHT = oi.WEIGHT,
                Texts = oi.Texts


CW:false
FSC:false
Texts:(3) [{…}, {…}, {…}]
ORDERED_BY:"W"
PEFC:false
PRODUCT_CODE:"GS520050R126501"
*/


import {Command} from './common';
import { WO_PRELIMINARY, WO_RELEASED } from '../util/constants';
function createOrderItemsFromState(state, cmd, release)
{

    return state.orderItems.map(oi=>({
            COPIED_FROM_ORDER_NUMBER: oi.COPIED_FROM_ORDER_NUMBER==undefined ? null : oi.COPIED_FROM_ORDER_NUMBER,
            COPIED_FROM_ORDER_ITEM_NUMBER: oi.COPIED_FROM_ORDER_ITEM_NUMBER==undefined ? null : oi.COPIED_FROM_ORDER_ITEM_NUMBER,
            ORDER_NUMBER: cmd==Command.Modify ? oi.ORDER_NUMBER : -1,
            ORDER_ITEM_NUMBER: cmd==Command.Modify ? oi.ORDER_ITEM_NUMBER : -1,
            ///CURRENCY_CODE : state.selectedCurrencyValue.value.value.CODE, currencyValue
            CURRENCY_CODE : state.currencyValue,
            CW_MARK : oi.CW_MARK==true ? 1 : 0,
            //DATE_ISSUED : null,
            DELIVERYTIME_DATE : oi.DELIVERYTIME_DATE,
            DELIVERYTIME_METHOD : oi.DELIVERYTIME_METHOD,
            DELIVERYTIME_WEEK : oi.DELIVERYTIME_WEEK,
            FSC : oi.FSC==true ? 1 : 0,     
            ORDER_ITEM_STATUS : state.disabled ? oi.ORDER_ITEM_STATUS : release ? WO_RELEASED : WO_PRELIMINARY,
            ORDER_ITEM_TYPE : '0',      
            PEFC : oi.PEFC==true ? 1 : 0,   
            PRODUCT_CODE : oi.PRODUCT_CODE,
            WEIGHT : oi.WEIGHT,
            WEIGHT_UC: oi.WEIGHT_UC,
            QUANTITY : oi.QUANTITY,
            ART_QUANTITY : oi.ART_QUANTITY,
            PRICE_UNIT : oi.PRICE_UNIT,
            UNIT_PRICE_COMMITTED : oi.UNIT_PRICE_COMMITTED,
            MILL_CODE : oi.MILL_CODE,
            DELIVERYTIME_TEXT:oi.DELIVERYTIME_TEXT,
            ORDERED_BY:oi.ORDERED_BY,
            //QUANTITY_UNIT: oi.QUANTITY_UNIT,
            Texts:oi.Texts.filter(t=>t.SELECTED==1).map(t=>(
                {
                    ORDER_NUMBER: cmd==Command.Modify ? oi.ORDER_NUMBER : -1,
                    ORDER_ITEM_NUMBER: cmd==Command.Modify ? oi.ORDER_ITEM_NUMBER : -1,
                    TEXT_CODE: t.TEXT_CODE,
                    TEXT_TYPE:t.TEXT_TYPE,
                    TEXT_CONTEXT:t.TEXT_CONTEXT,
                    SORT_INDEX:t.SORT_INDEX,
                    DESTINATION:null
                }
            )),
            DeselectedTexts:oi.Texts.filter(t=>t.SELECTED==0).map(t=>(
                {
                   ORDER_NUMBER: cmd==Command.Modify ? oi.ORDER_NUMBER : -1,
                   ORDER_ITEM_NUMBER: cmd==Command.Modify ? oi.ORDER_ITEM_NUMBER : -1,
                   TEXT_CODE: t.TEXT_CODE,
                   TEXT_TYPE:t.TEXT_TYPE,
                   TEXT_CONTEXT:t.TEXT_CONTEXT,
                   SORT_INDEX:t.SORT_INDEX,
                   DESTINATION:null
                }
           )),
            Instructions:oi.Instructions.map(t=>(
                {
                   ORDER_NUMBER: cmd==Command.Modify ? oi.ORDER_NUMBER : -1,
                   ORDER_ITEM_NUMBER: cmd==Command.Modify ? oi.ORDER_ITEM_NUMBER : -1,
                   INSTRUCTION_CODE: t.INSTRUCTION_CODE,
                   PRIORITY_INDEX:t.PRIORITY_INDEX,
                   SORT_INDEX:t.SORT_INDEX,
                   DESTINATION:null,
                   INSTRUCTION_TYPE:t.INSTRUCTION_TYPE
               }
           )),
        }
    ))
}


export {createOrderItemsFromState};